import { PickedTicket } from '~types';

const normalizeTickets = (tickets: PickedTicket[]): PickedTicket[] =>
  tickets.reduce<PickedTicket[]>((r, c) => {
    const index = r.findIndex((i) => i.code === c.code);
    if (index > -1) {
      r[index].qty = (r[index].qty || 0) + 1;
      return r;
    } else {
      return [...r, { ...c, qty: 1 }];
    }
  }, []);

export default normalizeTickets;
